<template>
  <q-page padding>
    <div class="row q-gutter-sm">
      <div class="col-12">
        <p class="text-h6 text-weight-bold text-brand-5 texto-titulo">
          Log Integração Usuários
        </p>
      </div>
    </div>
    <div
      class="row col-12 q-mt-md items-center q-gutter-sm text-weight-bold text-brand-5"
    >
      <div class="col-2">
        <div>Data Inicial</div>
        <q-input
          class="input"
          dense
          outlined
          placeholder="DD/MM/AAAA"
          mask="##/##/####"
          label="Digite a Data"
          label-color="grey-6"
          v-model="filtros.dataInicial"
        >
          <template v-slot:append>
            <q-icon name="event" class="cursor-pointer">
              <q-popup-proxy
                cover
                transition-show="scale"
                transition-hide="scale"
              >
                <q-date
                  v-model="filtros.dataInicial"
                  :locale="myLocale"
                  mask="DD/MM/YYYY"
                >
                  <div class="row items-center justify-end">
                    <q-btn v-close-popup label="Fechar" color="primary" flat />
                  </div>
                </q-date>
              </q-popup-proxy>
            </q-icon>
          </template>
        </q-input>
      </div>
      <div class="col-2">
        <div>Data Final</div>
        <q-input
          class="input"
          dense
          outlined
          placeholder="DD/MM/AAAA"
          mask="##/##/####"
          label="Digite a Data"
          label-color="grey-6"
          v-model="filtros.dataFinal"
        >
          <template v-slot:append>
            <q-icon name="event" class="cursor-pointer">
              <q-popup-proxy
                cover
                transition-show="scale"
                transition-hide="scale"
              >
                <q-date
                  v-model="filtros.dataFinal"
                  :locale="myLocale"
                  mask="DD/MM/YYYY"
                >
                  <div class="row items-center justify-end">
                    <q-btn v-close-popup label="Fechar" color="primary" flat />
                  </div>
                </q-date>
              </q-popup-proxy>
            </q-icon>
          </template>
        </q-input>
      </div>
      <div>
        <p></p>
        <q-btn
          label="Filtrar"
          color="primary"
          no-caps
          class="q-mt-xs"
          icon="filter_alt"
          @click="receberLogIntegracao()"
        />
      </div>
    </div>
    <div class="q-mt-xl">
      <div class="row col-12 justify-between items-center q-mb-sm">
        <div class="q-ml-md text-brand-5 text-weight-bold titulo-tabela">
          Lista de Logs
        </div>
      </div>
      <q-table
        flat
        :loading="loading"
        :columns="columns"
        dense
        :rows="listaLog"
        class="tabela-tamanho-fixo"
        :hide-bottom="!listaLog.length == 0"
        no-data-label="Nenhum log encontrado."
        table-header-class="bg-accent text-weight-bold"
        color="primary"
      >
        <template v-slot:body-cell-id="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.id }}
          </q-td>
        </template>
        <template v-slot:body-cell-criadoEm="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            <span>
              {{
                props.row?.criado_em
                  ?.split(" ")[0]
                  .split("-")
                  .reverse()
                  .join("/")
              }}
            </span>
            <span class="q-ml-sm">
              {{ props.row?.criado_em?.split(" ")[1] }}
            </span>
          </q-td>
        </template>
        <template v-slot:body-cell-erro="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.erro }}
          </q-td>
        </template>
        <template v-slot:body-cell-skip="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.skip }}
          </q-td>
        </template>
        <template v-slot:body-cell-topo="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.topo }}
          </q-td>
        </template>
        <template v-slot:body-cell-totalRegistros="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.total_registros }}
          </q-td>
        </template>
      </q-table>
      <div v-if="listaLog.length > 0" class="row justify-center q-mt-md">
        <q-pagination
          :disable="disable"
          v-model="pagination.page"
          color="brand-5"
          active-color="secondary"
          active-text-color="white"
          :max="pagesNumber"
          :max-pages="5"
          :boundary-numbers="false"
          :direction-links="true"
          size="sm"
        />
      </div>
    </div>
  </q-page>
</template>

<script>
import { onMounted, ref, computed, watch } from "vue";
import { useStore } from "vuex";

const columns = [
  {
    name: "id",
    label: "ID",
    align: "left",
  },
  {
    name: "criadoEm",
    label: "Criado Em",
    align: "left",
  },
  {
    name: "erro",
    label: "Erro",
    align: "left",
  },
  {
    name: "skip",
    label: "Skip",
    align: "left",
  },
  {
    name: "topo",
    label: "Top",
    align: "left",
  },
  {
    name: "totalRegistro",
    label: "Total de Registros",
    align: "left",
  },
];
export default {
  setup() {
    const store = useStore();

    const loading = ref(false);
    const disable = ref(false);
    const filtros = ref({
      dataInicial: "",
      dataFinal: "",
    });
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 10,
      rowsNumber: 6,
    });
    const listaLog = ref([]);

    const receberLogIntegracao = async (page = 1, per_page = 10) => {
      loading.value = true;
      disable.value = true;
      try {
        const response = await store.dispatch(
          "integracao/receberLogsIntegracao",
          {
            data_inicial: filtros.value.dataInicial,
            data_final: filtros.value.dataFinal,
            per_page,
            page,
          }
        );
        listaLog.value = response.data.data;
        loading.value = false;
        disable.value = false;
      } catch (error) {
        loading.value = false;
        disable.value = false;
      }
    };

    const gerarData = () => {
      let dataAtual = new Date();
      let dataInicial = new Date();
      dataInicial.setDate(dataAtual.getDate() - 15);

      let anoAtual = dataAtual.getFullYear();
      let mesAtual = (dataAtual.getMonth() + 1).toString().padStart(2, "0");
      let diaAtual = dataAtual.getDate().toString().padStart(2, "0");

      let anoInicial = dataInicial.getFullYear();
      let mesInicial = (dataInicial.getMonth() + 1).toString().padStart(2, "0");
      let diaInicial = dataInicial.getDate().toString().padStart(2, "0");

      filtros.value = {
        dataInicial: `${diaInicial}/${mesInicial}/${anoInicial}`,
        dataFinal: `${diaAtual}/${mesAtual}/${anoAtual}`,
      };
      receberLogIntegracao();
    };

    watch(
      () => pagination.value.page,
      () => {
        listaLog(pagination.value.page, pagination.value.rowsPerPage);
      }
    );

    onMounted(() => {
      gerarData();
    });

    return {
      filtros,
      columns,
      disable,
      gerarData,
      listaLog,
      receberLogIntegracao,
      pagination,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      loading,
      myLocale: {
        days: "Domingo_Segunda_Terça_Quarta_Quinta_Sexta_Sábado".split("_"),
        daysShort: "Dom_Seg_Ter_Quar_Quin_Sex_Sáb".split("_"),
        months:
          "Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro".split(
            "_"
          ),
        monthsShort: "Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split(
          "_"
        ),
        firstDayOfWeek: 1,
      },
    };
  },
};
</script>

<style scoped>
.titulo-tabela {
  font-size: 18px;
}
tbody tr td {
  white-space: pre-wrap;
}
@media (max-width: 600px) {
  .texto-titulo {
    font-size: 16px;
  }
  .titulo-tabela {
    font-size: 14px;
    margin-bottom: 10px;
    margin-left: 0px;
  }
}
</style>
